// import {
//   userStatus,
//   userProfile,
//   userAccount,
//   badgeDriveLicence,
// } from "./../interfaces/IUser";
import IUser from "../interfaces/IUser";
import APIService from "./API.service";
const queryString = require("query-string");

// interface IParamsCreate {
//   username?: string;
//   fullName?: string;
//   email?: string;
//   password?: string;
//   image?: string;
//   status?: userStatus;
//   profile?: userProfile;
//   account?: userAccount;
//   badgedrive_license?: badgeDriveLicence;
// }

class UserService extends APIService {
  //V1 login api
  loginV1(data: { username: string; password: string }): Promise<Response> {
    const request = new Request(
      `${this.apiUrl}/authentication/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    return fetch(request);
  }

  //V1 login api
  googleAuthUrlV1(payload: any): string {
    const { provider, origin } = payload || {};
    const apiUrl = this.apiUrl.replace('/rest', '');
    return `${apiUrl}/oauth2/authorization/${provider}?origin=${origin}`;
  }

  // Get list of users
  getUsers(search: string, start: number = 0): Promise<{ data: IUser[], count: Number }> {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      search,
      start,
    };

    return this.call.get(`${this.apiUrl}/users?${queryString.stringify(query)}`);
  }

  // Get one user
  getUser(userId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.get(`${this.apiUrl}/users/${userId}?${queryString.stringify(query)}`);
  }

  // Delete user
  delete(userId: number) {
    const token = localStorage.getItem("fielddrive-token");
    return this.call.delete(`${this.apiUrl}/users/${userId}?token=${token}`);
  }

  // Create User
  create(params: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    const postData = {
      username: params.username,
      password: params.password,
      account: params.account,
      badgedrive_license: params.badgedrive_license,
      email: params.email,
      fullName: params.fullName || "",
      image: params.image || "",
      profile: params.profile,
      status: params.status,
    };
    return this.call.post(
      `${this.apiUrl}/users?${queryString.stringify(query)}`,
      JSON.stringify(postData)
    );
  }

  // Update user
  update(params: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    const data = {
      username: params.username,
      password: params.password,
      account: params.account,
      badgedrive_license: params.badgedrive_license,
      email: params.email,
      fullName: params.fullName || "",
      image: params.image,
      profile: params.profile,
      status: params.status,
    };
    return this.call.put(
      `${this.apiUrl}/users/${params.id}?${queryString.stringify(query)}`,
      JSON.stringify(data)
    );
  }
}

export default UserService;
